import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'
const SESSION_KEY = 'page-loader-shown'

gsap.registerPlugin(SplitText, CustomEase)
CustomEase.create('smooth', 'M0,0 C0.38,0.005 0.215,1 1,1')
function splitLines(element) {
    if (element == null) return null

    return SplitText.create(element, {
        type: 'lines',
        mask: 'lines',
        linesClass: 'line'
    })
}

function homeBannerInit() {
    const homeBannerLogo = document.querySelector('[data-homebanner-logo]')

    if (homeBannerLogo == null) return

    const homeBannerMedia = document.querySelectorAll('.js-homebanner-media')
    const homeBannerTextLeft = document.querySelector('.js-homebanner-left')
    const homeBannerTextRight = document.querySelector('.js-homebanner-right')
    const textLeftSplit = splitLines(homeBannerTextLeft)
    const textRightSplit = splitLines(homeBannerTextRight)
    const hasSeenLoader = sessionStorage.getItem(SESSION_KEY) === 'true'

    const tl = gsap.timeline({
        delay: hasSeenLoader ? 0.2 : 4.3,
        defaults: {
            ease: 'smooth'
        }
    })

    if (hasSeenLoader) {
        tl.to(homeBannerMedia, {
            opacity: 1,
            duration: 0.7
        })
    } else {
        gsap.set(homeBannerMedia, {
            opacity: 1
        })
    }

    tl.from(
        homeBannerLogo,
        {
            yPercent: 100,
            duration: 0.7
        },
        '<'
    )

    if (textLeftSplit) {
        tl.from(
            textLeftSplit.lines,
            {
                yPercent: 110,
                duration: 0.8,
                stagger: 0.08
            },
            '<0.3'
        )
    }

    if (textRightSplit) {
        tl.from(
            textRightSplit.lines,
            {
                yPercent: 110,
                duration: 0.8,
                stagger: 0.08
            },
            '<0.1'
        )
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', homeBannerInit, {
        once: true
    })
} else {
    homeBannerInit()
}
